export function isSet(value) {
  return value !== null && value !== undefined;
}
